import { Chip, alpha, makeStyles } from '@material-ui/core';

import { getTypeOrNull } from '@spotify/confidence-graphql';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

const useStyles = makeStyles(theme => ({
  chip: {
    pointerEvents: 'none',
    verticalAlign: 'baseline',
    backgroundColor: alpha(theme.palette.background.default, 0.5),
    // Need these because the Backstage themes have margins on chips
    marginRight: 0,
    marginBottom: 0,
  },
}));

export interface MentionChipProps {
  displayName: string;
  name: string;
}

export const MentionChip = ({
  displayName,
  name,
}: {
  displayName: string;
  name: string;
}) => {
  const classes = useStyles();
  const { identity } = useIdentity({ name });
  const user = getTypeOrNull(identity?.user);

  return (
    <Chip
      component="span"
      size="small"
      className={classes.chip}
      label={`@${user?.fullName ?? identity?.displayName ?? displayName}`}
    />
  );
};
